export default __webpack_public_path__ + "static/questions-f13be56472d77221889d4aad2a5d73c8.svg";